import { render, staticRenderFns } from "./BirefringenceStressViz.vue?vue&type=template&id=3d71fbc4&scoped=true"
import script from "./BirefringenceStressViz.vue?vue&type=script&lang=js"
export * from "./BirefringenceStressViz.vue?vue&type=script&lang=js"
import style0 from "./BirefringenceStressViz.vue?vue&type=style&index=0&id=3d71fbc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71fbc4",
  null
  
)

export default component.exports